customElements.get("cart-related") || customElements.define("cart-related", class extends HTMLElement {
  constructor() {
    super(), this.mq = window.matchMedia("(max-width: 1024px)"), this.productCards = null, 
    this.isDesktopSetup = !1, this.titleEl = null, this.priceEl = null;
  }
  handleMouseEnter=e => {
    const t = e.currentTarget, i = t.querySelector(".product-card__title"), s = t.querySelector(".product-card__price");
    if (!i && !s) return;
    const r = i?.innerText, a = s?.innerHTML;
    this.titleEl && r && (this.titleEl.hasAttribute("data-original-text") || this.titleEl.setAttribute("data-original-text", this.titleEl.innerText), 
    this.titleEl.innerText = r), this.priceEl && a && (this.priceEl.innerHTML = a, this.priceEl.classList.remove("hidden"));
  };
  handleMouseLeave=e => {
    this.titleEl?.hasAttribute("data-original-text") && (this.titleEl.innerText = this.titleEl.getAttribute("data-original-text"), 
    this.titleEl.removeAttribute("data-original-text")), this.priceEl && (this.priceEl.innerHTML = "", 
    this.priceEl.classList.add("hidden"));
  };
  handleSimilarProductsLoaded=() => {
    this.productCards = this.querySelectorAll("product-card"), this.productCards.forEach(e => {
      e.addEventListener("mouseenter", this.handleMouseEnter), e.addEventListener("mouseleave", this.handleMouseLeave);
    });
  };
  setupDesktop() {
    this.isDesktopSetup || (this.titleEl || (this.titleEl = this.querySelector("[data-related-title]")), 
    this.priceEl || (this.priceEl = this.querySelector("[data-related-price]")), document.addEventListener("similar-products:loaded", this.handleSimilarProductsLoaded, {
      once: !0
    }), this.isDesktopSetup = !0);
  }
  destroyDesktop() {
    this.isDesktopSetup && (this.productCards && (this.productCards.forEach(e => {
      e.removeEventListener("mouseenter", this.handleMouseEnter), e.removeEventListener("mouseleave", this.handleMouseLeave);
    }), this.productCards = null), document.removeEventListener("similar-products:loaded", this.handleSimilarProductsLoaded), 
    this.isDesktopSetup = !1);
  }
  handleMediaQueryChange=e => {
    e.matches ? this.destroyDesktop() : this.setupDesktop();
  };
  connectedCallback() {
    this.mq.matches || this.setupDesktop(), this.mq.addEventListener("change", this.handleMediaQueryChange);
  }
  disconnectedCallback() {
    this.mq.removeEventListener("change", this.handleMediaQueryChange), this.destroyDesktop();
  }
});